import LoggerController from "../LoggerController"
import PlatformEvent from "../PlatformEvent";

export default new PlatformEvent("INFO", "SetupProgress", "SetupProgress")

// export default (step, type, logData, panelistAction) => {
//   LoggerController.sendLog("INFO", "SetupProgress", `${step} - ${type}`, false, panelistAction, "SetupProgress", {step, type, ...logData});
// };
